import { IGetData } from '../get-data';
import { AppMockConstants } from './mock-constants';

export class ExampleMock implements IGetData {
    private normalResponse = {
        example: null,
    } as unknown;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    getData(reqInfo: RequestInfo, db?: any): unknown {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const request = (reqInfo as any).req.body as any;

        if (request.reservationId === AppMockConstants.exampleMockId) {
            return this.normalResponse;
        } else {
            throw new Error('Not implemented');
        }
    }
}
